import React, { FunctionComponent, useState } from 'react';
import { PasswordInputProps, TextInput } from 'react-admin';
import { useTranslate } from 'ra-core';
import { IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useInputWithPolicies } from './useInputWithPolicies';
import { IAccessLevel } from '../../shared/utils/policyCheck';

type CommonPasswordInputProps = {
  ignorePolicies?: boolean;
} & PasswordInputProps &
  IAccessLevel;

const CommonPasswordInput: FunctionComponent<CommonPasswordInputProps> = (props) => {
  const { initiallyVisible = false, ...rest } = props;
  const [visible, setVisible] = useState(initiallyVisible);
  const translate = useTranslate();

  const handleClick = () => {
    setVisible(!visible);
  };
  return useInputWithPolicies(
    <TextInput
      type={visible ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={translate(
                visible
                  ? 'ra.input.password.toggle_visible'
                  : 'ra.input.password.toggle_hidden'
              )}
              onClick={handleClick}
              size="large"
            >
              {visible ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      variant="outlined"
      {...rest}
    />,
    props.source,
    props.level,
    props.ignorePolicies
  );
};

export default CommonPasswordInput;
